module.exports = __webpack_public_path__ + "static/_colorbase_-6450eea22e297ffbe74c5bfd67da8cc2.jpg";